import React, { memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorComponent from './ErrorComponent';
import LoaderComponent from './LoaderComponent';
import * as erroractions from '../error/ErrorAction';

const ErrorContainer = memo(() => {
    const dispatch = useDispatch();
    
    // Extract state using useSelector with performance optimization
    const {
        showError,
        apiError,
        errorCode,
        loadingIndicator
    } = useSelector(state => ({
        showError: state.errorReducer.showErrorMessage,
        apiError: state.errorReducer.apiError,
        errorCode: state.errorReducer.errorCode,
        loadingIndicator: state.errorReducer.loadingIndicator
    }));

    // Memoized callback to prevent unnecessary re-renders
    const closeError = useCallback(() => {
        dispatch(erroractions.removeErrorAction());
    }, [dispatch]);

    return (
        <>
            <ErrorComponent 
                showError={showError} 
                closeError={closeError} 
                apiError={apiError} 
                errorCode={errorCode} 
            />
            <LoaderComponent loadingIndicator={loadingIndicator} />
        </>
    );
});

// Display name for debugging
ErrorContainer.displayName = 'ErrorContainer';

export default ErrorContainer;